import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getLanguage } from "../../store/rootReducer";
import { setLanguage } from "../language/ducks/actions";
import logo from '../../assets/images/hrb-logo-horizontal.svg';
import './UpdateEmailHeader.scss';

class UpdateEmailHeader extends Component {

  handleLanguageToggle = () => {
    const newLanguage = this.props.language === 'en' ? 'fr' : 'en';
    this.props.setLanguage(newLanguage);
  };

  render() {
    const { language } = this.props;
    const currentLang = language ? language.toLowerCase() : 'en';
    
    return (
      <header className="hrb-update-email-header">
        <div className="hrb-update-email-header-logo">
          <img src={logo} alt="H&R Block" />
        </div>
        
        <div className="hrb-update-email-header-language-toggle">
          <div className="toggle-container">
            <button
              className={`toggle-button ${currentLang === 'en' ? 'selected' : ''}`}
              onClick={() => this.props.setLanguage('en')}
            >
              En
            </button>
            <button
              className={`toggle-button ${currentLang === 'fr' ? 'selected' : ''}`}
              onClick={() => this.props.setLanguage('fr')}
            >
              Fr
            </button>
          </div>
        </div>
      </header>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: getLanguage(state)
  };
};

const mapDispatchToProps = {
  setLanguage
};

export default connect(mapStateToProps, mapDispatchToProps)(UpdateEmailHeader);
